/* eslint-disable quotes, max-len */
export default {
    a_list_is_required: "a List is required",
    accept_and_schedule: "Accept & Schedule",
    accepted_files_types: "Accepted File Types:",
    account_deactivated: "This account has been deactivated.",
    accumulated_points: "Accumulated Points",
    accumulated_points_calculates_the_total_point_value: "Accumulated points calculates the total point value possible for the survey",
    acknowledge: "Acknowledge",
    acknowledgment_required: "Acknowledgment Required",
    actions: "Actions",
    activate: "Activate",
    activate_client_body: "You can deactivate this client again at any time.",
    activate_client_title: "You are about to activate this client",
    activate_project: "Activate Project",
    active: "Active",
    active_project_editing_alert: "Any changes to these details could have impacts on active projects.",
    active_tags: "Active Tag(s)",
    activity: "Activity",
    activity_details: "Activity Details",
    activity_log: "Activity Log",
    activity_name: "Activity Name",
    activity_number: "Activity Number",
    activity_overview: "Activity Overview",
    activity_status: "Activity Status",
    actual_time: "Actual Time",
    add: "Add",
    add_a_filter: "Add a Filter",
    add_a_job: "Add a Job",
    add_a_link: "Add a Link",
    add_a_question: "Add a Question",
    add_a_tag: "Add a Tag",
    add_assignment_to_project: "Add Assignments to Project",
    add_client: "Add Client",
    add_display_logic: "Add Display Logic",
    add_instructions_here: "Add Instructions Here",
    add_item_requests: "Add Item Requests",
    add_item_set_to_question: "Add Item Set to Question",
    add_items: "Add Items",
    add_items_to_item_set: "Add Items to Item Set",
    add_links: "Add Links",
    add_location: "Add Location",
    add_locations: "Add Locations",
    add_note: "Add Note",
    add_opportunities: "Add Opportunities",
    add_or_remove_items: "Add or remove items",
    add_rep: "Add Rep",
    add_reps: "Add Reps",
    add_roles: "Add Roles",
    add_survey_text: "button to attach questions to this work.",
    add_tag: "Add Tag",
    add_tags: "Add Tags",
    add_to_max_custom_fields: "Maximum 30 custom fields.",
    add_to_selections: "Add to Selections",
    add_values: "Add Values",
    added: "Added",
    additional_email_recipients: "Additional Email Recipients",
    additional_info: "Additional Info",
    additional_work: "Additional Work",
    address: "Address",
    address2: "Additional Address",
    address_2: "Additional Address",
    address_details_title: "Address Details",
    addresses: "Addresses",
    adjust_filter_preamble: " | Adjust or",
    adjust_filters: "Please adjust the filter set to populate data",
    adjust_person_and_project_filters: "Adjust your person and project identifier filters.",
    adjust_person_filters: "Adjust your person filters.",
    adjust_project_filters: "Adjust your project identifier filters.",
    adjust_search: "Please adjust search to populate data or ",
    adjust_the_filter_set: "adjust the filter set",
    admin_return: "Back to Awesome Admin",
    admin_settings: "Admin Settings",
    advanced_details_title: "Advanced Details",
    after: "After",
    after_number_of_occurrences: "After # of Occurrences",
    after_work_is_due: "After Work is Due",
    all: "All",
    all_day: "All Day",
    all_master_questions: "All Master Questions",
    all_opportunities_created: "All Opportunities Created",
    all_options_must_have_text: "All options must have text.",
    all_partial_parameter_sub_text: "To create Opportunities for any Open Visits please adjust your Parameters and Staff Requirements.",
    all_priorities: "All Priorities",
    all_questions_must_contain_text: "All questions must contain text.",
    all_retailer_or_custom_field_selected_message: "We've streamlined your selection to use 'All Locations' for improved efficiency. Rest assured, this adjustment won't impact your carefully selected locations.",
    all_roles: "All Roles",
    all_skills_and_capabilities: "All Skills & Capabilities",
    all_time_limited_to_completed: "All Time limited to Completed",
    all_times_displayed_in_location_timezone: "All times displayed in Location timezone",
    allow_barcode_scanner: "Allow barcode scanner",
    allow_decimals: "Allow Decimals",
    allow_email_addresses_of_existing_reps: "Allow E-mail Addresses of Existing Reps",
    allow_recipients_to_refresh_report_data: "Allow recipients to refresh report data",
    allowed_to_schedule: "Allowed to Schedule",
    alphanumeric_and_spaces_and_dashes_only: "Only alphanumeric characters, spaces, and dashes are allowed.",
    already_exists_in_the_database: "already exists in the database",
    amp_by_movista: "AMP by Movista",
    and: "and",
    announcement_title: "Announcement Title",
    announcements: "Announcements",
    answers_link: "Answers Link",
    anyone_can_see_this: "Anyone can see the name of this event.",
    anytime: "Anytime",
    anytime_after: "Anytime after",
    anytime_before: "Anytime before",
    api_error_message: "We are unable to complete your request at this time. Please try again later.",
    app_version: "App Version",
    apply: "Apply",
    apply_filters: "Apply Filters",
    approval_feedback_will_be_emailed_to_the_rep: "Approval feedback will be emailed to the rep",
    approve: "Approve",
    approve_visit: "Approve Visit",
    approved: "Approved",
    apr: "Apr",
    archive: "Archive",
    archived: "Archived",
    are_late: "are Late",
    are_you_sure_you_want_to_delete_the: "Are you sure you want to delete the",
    are_you_sure_you_want_to_delete_the_existing_visit_details: "Are you sure you want to delete the existing visit details?",
    are_you_sure_you_want_to_delete_this: "Are you sure you want to delete this?",
    are_you_sure_you_want_to_delete_this_attribute: "Are you sure you want to delete this attribute",
    are_you_sure_you_want_to_delete_this_gallery: "Are you sure you want to delete this gallery?",
    are_you_sure_you_want_to_delete_this_note: "Are you sure you want to delete this note?",
    are_you_sure_you_want_to_delete_this_report: "Are you sure you want to delete this report?",
    are_you_sure_you_want_to_remove_these_photos_from_this_gallery: "Are you sure you want to remove these photos from this gallery?",
    are_you_sure_you_want_to_unassign_this_visit_from_this_person: "Are you sure you want to remove this event from the schedule? The event can then be added to another person's schedule.",
    assignable: "Assignable",
    assigned_locations: "Assigned Locations",
    assigned_role: "Assigned Role",
    assigned_role_s: "Assigned Role(s)",
    assigned_roles: "Assigned Roles",
    assigned_staff: "Assigned Staff",
    assigned_staff_direct_supervisor: "Assigned Staff's Direct Supervisor(s)",
    assigned_staff_level2_supervisor: "Assigned Staff's Level 2 Supervisor(s)",
    assigned_staff_level3_supervisor: "Assigned Staff's Level 3 Supervisor(s)",
    assigned_staff_top_level_supervisor: "Assigned Staff's Top Level Supervisor(s)",
    assigned_to: "Assigned to",
    assigner: "Assigner",
    assignment_type: "Assignment Type",
    assignment_value: "Assignment Value",
    assignment_values: "Assignment Values",
    assignments: "Assignments",
    assignments_visits_title: "Assignments & Visits",
    at: "at",
    at_column: "at column",
    at_risk: "At risk to be late",
    at_risk_short: "At Risk",
    at_risk_to_be_late_status: "At Risk To Be Late Status",
    atrisk_default_details: "The Project's progress will be monitored to determine if it can be completed on time. We calculate if an on time completion is possible based upon the Projects's submitted percentage and the number of days remaining.",
    atrisk_manual_details: "The Project will be flagged as At Risk to be Late depending on your specifications. Choose the number of days before the due date and submitted percentage threshold you would like the Project to reach or it will be flagged as At Risk to be Late.",
    attach_image: "Attach Image",
    attached_to_a_question: "Attached to a Question",
    attribute_values: "Attribute Values",
    attributes: "Attributes",
    attributes_title: "Attributes",
    audited_miles: "Audited Miles",
    audited_miles_authorized: "Audited Miles Authorized",
    aug: "Aug",
    auto_approve_work: "Auto Approve Work",
    auto_approve_work_after: "Auto Approve Work After",
    auto_approve_work_help: "Manage when the project will auto-approve. If a time interval is selected, once a visit has been submitted and the visit is not approved within the selected time it will automatically approve. Default is \"Never\" auto-approve.",
    automatic_values_required: "Planogram Completion Display Text Required",
    availability: "Availability",
    average_completed: "Average Completed",
    average_completion: "Average Completion %",
    average_pay_rate: "Average Pay Rate",
    average_pay_rate_dollars: "Average Pay Rate (dollars)",
    average_time: "Average Time",
    average_time_minutes: "Average Time (minutes)",
    back: "Back",
    bar: "Bar",
    based_available_data_no_visualizations_generated: "Based on the available data points, no visualizations are able to be generated.",
    based_on_project_due_date: "Based on your Project's Due Date",
    based_on_project_progress: "Based on your Projects's Progress",
    basic_details_title: "Basic Details",
    basic_setting: "Basic Settings",
    basic_settings: "Basic Settings",
    basic_work_details_title: "Basic Work Details",
    batch_edit_locations: "Edit Locations",
    bcc_recipients: "BCC Recipient(s)",
    before_work_is_due: "Before Work is Due",
    beginning_of_range_must_be: "Beginning of range must be less than end of range",
    billing: "Billing",
    billing_address: "Billing Address Street 1",
    billing_address_2: "Billing Address Street 2",
    billing_city: "Billing City",
    billing_code: "Billing Code",
    billing_codes: "Billing Codes",
    billing_codes_label: "Billing Code(s)",
    billing_country: "Billing Country",
    billing_details_title: "Billing Details",
    billing_number: "Billing Number",
    billing_pay_title: "Billing & Pay",
    billing_rate: "Billing Rate",
    billing_rate_help: "Enter the project billing rate based on your billing type selection.",
    billing_state: "Billing State/Province",
    billing_type: "Billing Type",
    billing_type_help_flat: "Billing based on a fixed amount for each work submission.",
    billing_type_help_hourly: "Billing based on hours worked by staff.",
    billing_type_help_none: "Billable amounts not tracked.",
    billing_type_help_title: "Billing Type selection determines the method of client billing for the project work:",
    billing_zip: "Billing Postal Code",
    both_carrier_and_tracking_numbers_is_required: "Both Carrier & Tracking Number(s) is required",
    both_due_date_and_due_time_is_required: "Both Due Date & Due Time is required",
    both_pay_type_and_pay_rate_is_required: "Both Pay Type & Pay Rate is required",
    both_start_date_and_start_time_is_required: "Both Start Date & Start Time is required",
    brand: "Brand",
    breadcrumb_trail: "Breadcrumb Trail",
    broker: "Broker",
    browse: "browse",
    bulk_actions: "Bulk Actions",
    bulk_edit_visit_details: "Bulk Edit Visit Details",
    bulk_management: "Bulk Management",
    bulk_options: "Bulk Options",
    bulk_update_attributes: "Bulk Update Attributes",
    button_to_create_opportunities: "button to create opportunities.",
    button_to_get_started: "button to get started",
    by_enabling_exchange: "By enabling Exchange you are giving permissions to data sharing within your domain",
    by_movista: "By Movista",
    by_navigating_on_this_site_you_agree_and_consent_to_our_user: "By navigating on this site you agree and consent to our user ",
    calendar_preview: "Calendar Preview",
    calender_preview: "Calender Preview",
    canada: "Canada",
    cancel: "Cancel",
    cancel_reissue: "Cancel Reissue",
    canceled: "Canceled",
    capital_unit_of_measure: "Miles",
    card_id: "Card ID",
    carrier: "Carrier",
    cashier: "Cashier",
    category: "Category",
    cell_phone: "Cell Phone",
    chain: "Chain",
    chains: "Chains",
    changes_published: "Changes Published",
    changes_saved: "Changes Saved",
    changing_the_input_type_will_require_staff_to_be_reassigned: "Changing the Input Type will require Staff to be re-assigned to any/all Attribute Values under",
    characters: "Characters",
    check_in_slash_check_out_time: "Check-In / Check-Out Time",
    check_in_slash_out_time: "Check-In/Out Time",
    check_in_time: "Check-In Time",
    checked_in: "Checked In",
    cities: "Cities",
    city: "City",
    clear: "Clear",
    clear_cache: "Clear Session Cache",
    clear_chart_filter: "Clear chart filter",
    clear_filters: "Clear Filters",
    clear_search: "clear search",
    clear_selection: "Clear Selection",
    clear_selections: "Clear Selections",
    click_here_to_download_csv_of_failed_locations_and_reupload: "Click Here to download CSV of failed locations and reupload",
    click_ok_to_schedule_anyway: "Click ok to schedule anyway",
    click_on_a_photo_to_view_its_attributes: "Click on a photo to view its attributes.",
    client: "Client",
    client_address: "Client Address Street 1",
    client_address_additional: "Client Address Street 2",
    client_code: "Client Code",
    client_code_help: "Client code is a unique identifier assigned to a client to track interactions and transactions. It is usually composed of letters, numbers, or symbols specific to the client.",
    client_deleted_succesfully: "Client Deleted Successfully",
    client_details_title: "Client Details",
    client_help: "Enter any value for a client you'd like to associate to this project for reporting. This entry is optional.",
    client_id_invalid: "Invalid client id",
    client_label: "Client",
    client_list: "Client List",
    client_manager: "Client Manager",
    client_name: "Client Name",
    client_name_invalid_tooltip: "Client Name cannot match another client record",
    client_name_similar_tooltip: "Existing Clients with a Similar Name",
    client_number: "Client Number",
    client_number_help: "Client number is a unique identifier assigned to a client to manage the client's account and identify them in the system.",
    client_project_number_help: "Enter any number to associate with this project work. This project number can be reused across multiple projects. This entry is optional.",
    client_project_number_label: "Client Project #",
    client_status_help: "Assign a client status to control the ability to use the client within the Movista portal.",
    client_type: "Client Type",
    clients: "Clients",
    clocked_in: "Clocked In",
    close: "Close",
    club: "Club",
    club_time: "Club Time",
    column: "Column",
    columns: "Columns",
    communications: "Communications",
    company_settings: "Company Settings",
    complete: "Complete",
    complete_alert_help: "Manage which projects will include the additional request to validate the project visit completion status in the app. If enabled, when a project visit is submitted in the app, staff will receive an additional completion confirmation request.",
    complete_planogram: "Complete Planogram",
    completed: "Completed",
    completed_date: "Completed Date",
    completed_date_filter_required: "Completed Date Filter required",
    completed_planogram: "I completed the planogram.",
    completed_projects: "Completed Projects",
    completed_projects_default: "Projects that have ended. These projects will no longer provide health status.",
    completion_details: "Completion Details",
    completion_overview: "Completion Overview",
    condition: "Condition",
    conditional_logic: "Conditional Logic",
    configuration_set: "Configuration Set",
    configure_default_date: "Configure Default Date",
    configure_maximum_date: "Configure Maximum Date",
    configure_minimum_date: "Configure Minimum Date",
    confirm: "Confirm",
    confirm_activate_rep_title: "Activate Staff Member",
    confirm_cancel: "Confirm Cancel",
    confirm_delete: "Confirm Delete",
    confirm_delete_announcement_dialog_title: "Are you sure you want to discard this announcement?",
    confirm_discard: "Confirm Discard",
    confirm_end_mplan: "Confirm End Project",
    confirm_invitation_deletion_body: "The invited person will no longer be able to register for Movista using the email they received.",
    confirm_invitation_deletion_title: "Are you sure you want to delete the invitation?",
    confirm_publish_draft: "Do you want to activate this project?",
    connection_details: "Connection Details",
    connection_id: "Connection ID",
    connection_initiating_instruction: "You are about to initiate this Connection. To view the status of your connection request, visit the Client Manager Exchange screen.",
    connection_name: "Connection Name",
    connections: "Connections",
    connections_instruction: "Select a client that exists in your client list. If you do not see the client you're looking for, please add them <here>.",
    connections_instruction_2: "To initiate the connection on the client's side, provide the Exchange Contact Email address to send them a link for activation.",
    contact: "Contact",
    contact_details_title: "Contact Details",
    contact_manager_sentence: "Contact your manager if you believe you have the wrong login credentials.",
    contact_name: "Contact Name",
    contacts: "Contacts",
    contains_invalid_characters: "Contains Invalid Character(s)",
    continue: "Continue",
    control_response_values: "Control Response Values",
    conversation_deactivated: "This conversation has been deactivated.",
    copied_clipboard: "Copied to Clipboard",
    copy: "Copy",
    copy_and_create_new: "Copy and Create New",
    copyright: "Copyright",
    could_not_load_people: "Could Not load people.",
    count: "Count",
    countries: "Countries",
    country: "Country",
    create: "Create",
    create_a_project: "Create a Project",
    create_a_section: "Create a section,",
    create_a_template: "Create a Template",
    create_additional_opportunities: "Create Additional Opportunities",
    create_an_attribute: "Create an attribute,",
    create_announcement: "Create Announcement",
    create_announcements: "Create Announcements",
    create_connection: "Create Connection",
    create_custom_field: "Create Custom Field",
    create_description_help: "Enter a description of the project work to be completed. This will only be visible within the web platform and not within the app.",
    create_gallery: "Create Gallery",
    create_item_set: "Create Item Set",
    create_item_set_summary: "Define a group of related items, which can be used to create item-based survey questions.",
    create_list: "Create List",
    create_message_back: " button in the top right corner.",
    create_message_front: "Create a new message by tapping the ",
    create_new: "Create New",
    create_new_announcement: "Create a new announcement now!",
    create_new_custom_field: "Create New Custom Field",
    create_new_item_set: "Create Item Set",
    create_new_list: "Create New List",
    create_new_people_attribute: "Create New People Attribute",
    create_new_report: "Create New Report",
    create_note: "Create Note",
    create_opportunities: "Create Opportunities",
    create_photo_gallery: "Create Photo Gallery",
    create_project: "Create Project",
    create_report: "Create Report",
    create_survey: "Create Survey",
    create_tag: "Create Tag",
    create_template: "Create Template",
    create_work: "Create Work",
    created_by: "Created By",
    created_date: "Created Date",
    created_on: "Created On",
    creator: "Creator",
    criteria: "Criteria",
    csv: "CSV",
    cumulative_photo: "Cumulative Photo",
    cumulative_response: "Cumulative Response",
    cumulative_responses: "Cumulative Responses",
    cumulative_sbl_photo: "Cumulative SBL Photo",
    cumulative_sbl_response: "Cumulative SBL Response",
    current_branch: "Branch",
    current_calendar: "Current Calendar",
    current_location: "Current Location",
    custom: "Custom",
    custom_attributes: "Custom Attributes",
    custom_date: "Custom Date",
    custom_date_explanation: "Use a custom date for the default date",
    custom_end_date: "Custom End Date",
    custom_field: "Custom Field",
    custom_field_delete_end: "has been deleted.",
    custom_field_values_save_failed: "Custom Field Values Save Failed",
    custom_field_values_saved_successfully: "Custom Field Values Saved Successfully",
    custom_fields: "Custom Fields",
    custom_unit_label: "Custom Unit Label",
    customer_service: "Customer Service",
    daily: "Daily",
    daily_recurring_error: "A daily recurring cannot last longer than one day.",
    dashboard: "Dashboard",
    dashboards: "Dashboards",
    data_grid: "Data Grid",
    data_refresh_alert: "Data Refreshed. The page will now reload",
    data_set_too_large_select_to_search: "Data set too large. Select to Search",
    data_sets_too_large_adjust_filters: "The data sets below are too large. In order to give you the best experience, adjust the filters for the following data sets.",
    data_successfully_imported: "Data Successfully Imported",
    data_warehouse: "Data Warehouse",
    date: "Date",
    date_created: "Date Created",
    date_parameters_title: "Date Parameters",
    date_question_explanation: "This question type allows app users to submit a date range response, with optional configurations constraining submissions to a Project Date range.",
    date_range: "Date Range",
    date_range_type: "Date Range Type",
    date_shipped: "Date Shipped",
    date_slash_time: "Date / Time",
    date_submitted: "Date Submitted",
    date_time_parameters_title: "Date & Time Parameters",
    dates: "Dates",
    dates_and_times: "Dates & Times",
    day: "day",
    day_of_the_month: "Day of the Month",
    day_of_the_week: "Day of the Week",
    day_option: "Day(s)",
    day_range_feedback: "Must be between 0-24",
    days: "days",
    days_prior_to_due_date: "Days prior to due date",
    days_remaining: "days remaining",
    deactivate: "Deactivate",
    deactivate_client_body: "No client data will be lost. You can activate this client again at any time.",
    deactivate_client_title: "You are about to deactivate this client",
    deactivate_tag: "Deactivate Tag",
    deactivated: "deactivated",
    dec: "Dec",
    decline_opportunity: "Decline Opportunity",
    decline_the_opportunity: "Decline the Opportunity",
    decommission: "Decommission ",
    decommission_reps: "Decommission Reps",
    decommissioned_inactive: "Decommissioned/Inactive",
    decommissioning_are_you_sure: "Are you sure you want to do this? This action cannot be undone.",
    decommissioning_they_will_no_longer: "They will no longer have access to the kiosk or work logs, and their information will no longer be available.",
    decommissioning_this: "Decommissioning this",
    decommissioning_these_reps: "Decommissioning these reps ",
    decommissioning_will_remove_status: "will remove their status as a Movista representative. ",
    default: "Default",
    default_cannot_be_greater_than_max: "Default value cannot be greater than the maximum value.",
    default_cannot_be_less_than_min: "Default value cannot be less than the minimum value.",
    default_cannot_be_less_than_min_greater_than_max: "Default value cannot be less than the minimum value and cannot be greater than the maximum value.",
    default_date: "Default Date",
    default_date_explanation: "Use the defined default date",
    default_value: "Default Value",
    delete: "Delete",
    delete_a_job: "Delete a Job",
    delete_announcement: "Delete Announcement",
    delete_announcement_dialog_title: "Are you sure you want to delete this attachment?",
    delete_attribute: "Delete Attribute",
    delete_client: "Delete Client",
    delete_client_confirmation: "You are about to delete a Client",
    delete_client_dialog_title: "Are you sure you want to delete this Client?",
    delete_conversation: "Delete Conversation",
    delete_custom_field: "Delete Custom Field",
    delete_custom_field_confirmation: "Are you sure you want to delete this custom field?",
    delete_draft: "Delete Draft",
    delete_draft_confirmation: "You are about to delete a draft Project",
    delete_draft_dialog_title: "Are you sure you want to delete this draft?",
    delete_event: "Delete Event",
    delete_for_everyone: "Deleting this announcement will remove it for everyone.",
    delete_gallery: "Delete Gallery",
    delete_image: " Delete Image",
    delete_invitation: "Delete Invitation",
    delete_item_set: "Delete Item Set",
    delete_item_set_confirmation: "Are you sure you want to delete this Item Set? This action cannot be undone.",
    delete_list: "Delete List",
    delete_list_confirmation: "Are you sure you want to delete this list?",
    delete_lists: "Delete Lists",
    delete_lists_confirmation: "Are you sure you want to delete these lists?",
    delete_note: "Delete Note",
    delete_order: "Delete Order",
    delete_question: "Delete Question",
    delete_questions: "Delete Questions",
    delete_recurring_event: "Delete Recurring Event",
    delete_recurring_event_confirmation: "Are you sure you want to delete this recurring event?",
    delete_report: "Delete Report",
    delete_section: "Delete Section",
    delete_selected_lists: "Delete Selected Lists",
    delete_sent_dialog_title: "Are you sure you want to delete this announcement?",
    delete_template: "Delete Template",
    delete_template_confirmation: "You are about to delete a template.",
    delete_workgrid: "Delete mPlan",
    delete_workgrid_confirmation: "You are about to delete a completed mPlan",
    delete_workgrid_pending_confirmation: "You are about to delete a pending mPlan",
    deleting_this_parent_question_will_delete_all_of_its_child_questions: "Deleting this parent question will delete all of the conditional questions that depend on it.",
    deleting_this_template: "Deleting this template will not affect existing Projects.",
    deleting_this_value_will_remove_it_from_all_user_profiles: "Deleting this value will remove it from all user profiles.",
    deleting_this_value_will_remove_it_from_this_section: "Deleting this value will remove it from this section.",
    department: "Department",
    description: "Description",
    deselect_all: "Deselect All",
    details: "Details",
    device_id: "Device ID",
    device_miles: "Device Miles",
    device_model: "Device Model",
    device_os: "Device OS",
    device_rep_reported_variance: "Device/Rep Reported Variance",
    device_route_variance: "Device/Route Variance",
    did_not_complete_planogram: "I did not complete the planogram.",
    discard: "Discard",
    discard_all_unsaved_changes: "You are about to discard any unsaved changes.",
    discard_changes: "Discard Changes",
    disguise: "Disguise",
    disguise_as_admin: "Disguise as Admin",
    disguise_as_user: "Disguise as User",
    dismiss: "Dismiss",
    display: "Display",
    display_values: "Display Values",
    distance: "Distance",
    distance_to_store_kilometers: "Distance to Store (Kilometers)",
    distance_to_store_miles: "Distance to Store (Miles)",
    distributor: "Distributor",
    do_you_want_to_continue_reissuing_this_occurrence: "Do you want to continue reissuing this occurrence?",
    dob: "DOB",
    does_not_exist: " does not exist",
    does_not_include_projects: "Does not include Infinity, Excluded, Pending, or Completed projects.",
    download: "Download",
    download_jpg: "Download JPG",
    download_png: "Download PNG",
    download_template: "Download Template",
    downloads: "Downloads",
    draft: "Draft",
    draft_announcements: "Your draft announcements will be stored here.",
    draft_mplans: "Draft Name",
    draft_saved: "Draft Saved",
    drafts: "Drafts",
    drop_pdf_here_or: "Drop your PDF here or",
    drop_your_csv_here_or: "Drop your CSV here or",
    drop_your_file_here_or: "Drop your file here or",
    drop_your_files_here_or: "Drop your files here or",
    drop_your_image_here: "Drop your image here or ",
    drop_your_xlsx_here_or: "Drop your xlsx here or",
    due: "Due",
    due_current_time_error: "Due Date/Time must be after current Date/Time.",
    due_date: "Due Date",
    due_date_help: "Default due date of the project ends at 00:01 on the selected date. Set another defined due time if the latest start time of the work should be earlier in the mobile app.",
    due_date_must_be_after_initial_start_date: "Due Date(s) must be after initial Start Date(s)",
    due_date_past_error: "Due date cannot be in the past.",
    due_date_time: "Due Date/Time",
    due_dates: "Due Date(s)",
    due_end_error: "Due Date is after the recurring end date.",
    due_on_month_end: "Due on Month End",
    due_start_time_error: "Due Time cannot be the same or before than the Start Time.",
    due_time: "Due Time",
    duplicat_item_set_name: "Duplicate Item Set Name",
    duplicate: "Duplicate",
    duplicate_all: "Duplicate All",
    duplicate_custom_field: "Duplicate Custom Field",
    duplicate_list_name: "Duplicate List Name",
    duplicate_schedule: "Duplicate Schedule",
    duplicate_value: "Duplicate Value",
    duration: "Duration",
    dynamic_entry: "Dynamic Entry",
    each_display_value_must_have_reporting_value: "Each line with a display value must also have a reporting value.",
    edit: "Edit",
    edit_assignments: "Edit Assignments",
    edit_attachment: "Edit Attachment",
    edit_custom_field: "Edit Custom Field",
    edit_draft: "Edit Draft",
    edit_gallery: "Edit Gallery",
    edit_item: "Edit Item",
    edit_item_requests: "Edit Item Requests",
    edit_item_set: "Edit Item Set",
    edit_item_set_name: "Edit Item Set Name",
    edit_list_name: "Edit List Name",
    edit_location: "Edit Location",
    edit_note: "Edit Note",
    edit_people_attribute: "Edit People Attribute",
    edit_recurring_event: "Edit Recurring Event",
    edit_reps: "Edit Reps",
    edit_roles: "Edit Roles",
    edit_super_admins: "Edit Super Admins",
    edit_visit_details: "Edit Visit Details",
    edit_visit_details_description: "You can assign visit-specific information by downloading the template file, entering the details for each location, and importing the file.",
    edit_visit_details_via_csv: "Edit Visit Details via CSV",
    edit_visit_details_warning: "Importing a new file will overwrite the existing location details. To modify existing details, download the file again. The existing details will be included in the template.",
    edited_by: "Edited By",
    eg_entering_8_to_10_will_display_the_question_if_they_answer_8_9_or_10: "E.g. entering 8 to 10 will display the question if they answer 8, 9, or 10",
    email: "Email",
    email_address: "Email Address",
    email_address_list: "Enter email address(es)",
    email_error: "Incorrect Email Format",
    email_mplan_responses: "Email Visit Responses",
    email_recipients: "Email Recipient(s)*",
    emails_receiving_alert: "Email Addresses Receiving Alert",
    emp_id: "Emp ID",
    employee: "Employee",
    employee_assigned: "Employee Assigned",
    employee_details: "Employee Details",
    employee_id: "Employee ID",
    employee_name: "Employee Name",
    empty_question_text: "Enter Your Question Text Here",
    enable_bulk_management: "Enable Bulk Management",
    enabling_bulk_management_message: "Enabling bulk management will turn on use of the Bulk Management options",
    enable_client_manager: "Enable Client Manager",
    enable_exchange: "Enable Exchange",
    enable_external_project_links: "Enable External Project Links",
    enable_hierarchy: "Enable Staff Hierarchy",
    enable_hub: "Enable Hub",
    enable_profile: "Enable Profile",
    enable_rep_hub: "Enable People Hub",
    enable_tag_manager: "Enable Tag Manager",
    enabling_rep_hub_will_turn_on: "Enabling hub will turn on use of the Athena People Hub",
    enabling_rep_profile_will_turn_on: "Enabling profile will turn on use of the Athena Rep Profile",
    end: "End",
    end_after_number_occurrences: "End After a Number of Occurrences",
    end_date: "End Date",
    end_date_explanation: "Use the end date of the project",
    end_date_help: "If the project ends on the due date, then the project will end on the entered due date & time.",
    end_date_must_be_after_initial_start_date: "End Date(s) must be after initial Start Date(s)",
    end_dates: "End Date(s)",
    end_mplan_body: "Are you sure you want to end this Project?",
    end_of_range_must_be: "End of range must be greater than beginning of range",
    end_time: "End Time",
    end_time_is_required: "End Time is required.",
    end_type: "End Type",
    end_type_changed_to_due_date: "End Type Changed to \"Due Date\"",
    ending_on: "ending on",
    enforce_due_time: "Enforce Due Time",
    enforce_start_time: "Enforce Start Time",
    ensure_decimal_places_are_correct: "Ensure decimal places are correct.",
    enter_connection_details: "Enter Connection Details",
    enter_text: "Enter Text",
    enter_value_or_click_minus_button_to_delete: "Enter value or click minus button to delete",
    enter_values_for_this_attribute: "Enter values for this attribute.",
    enter_values_here: "Enter values here",
    enter_values_into_boxes: "Enter values into the text box(es)",
    enter_values_separated_by_a_comma_or_return: "Enter values separated by a comma or return",
    enter_your_own_threshold: "Enter Your Own Threshold",
    entry_date: "Entry Date",
    entry_date_explanation: "Use the current date of the app user",
    error_400: "Request Invalid",
    error_401: "Request Unauthorized",
    error_403: "Request Forbidden",
    error_404: "Not Found",
    error_409: "Conflict",
    error_500: "Server Error",
    error_502: "Bad Gateway",
    error_503: "Service Unavailable",
    error_504: "Gateway Timed Out",
    error_507: "Insufficient Storage",
    error_message: "We are unable to complete your request right now. Please try again later.",
    error_page_not_found: "This page cannot be found",
    error_page_not_found_text: "The content you're trying to reach may have been deleted, or you may not have access to it.",
    error_refreshing_data: "Whoops! An error when refreshing data ocurred",
    error_uploading_file: "Error uploading file to server",
    error_while_updating_estimated_time: "Error while updating Estimated Time",
    errors: "Errors",
    escalate_to_projects_assigned_roles: "Escalate to the project's assigned roles(s)",
    escalation_paths_based_off_staff_member_assigned: "The escalation paths will be based off of the staff member who has been assigned and will sort chronologically.",
    estimated_rep_pay: "Estimated Rep Pay",
    estimated_time: "Estimated Time",
    estimated_time_in_minutes: "Estimated Time (Minutes)",
    estimated_time_to_complete_work: "Estimated Time to Complete Work",
    event: "Event",
    event_details: "Event Details",
    events: "Events",
    every: "Every",
    ex_items: "Ex: \"Items\"",
    ex_namesite: "Ex. name@site.com",
    excel: "Excel",
    exchange: "Exchange",
    exchange_client: "Exchange Client",
    exchange_contact: "Exchange Contact Name",
    exchange_contact_email: "Exchange Contact Email",
    exchange_email: "Exchange Email",
    exchange_opt_in: "Exchange Opt In",
    exclude_gps: "Exclude GPS",
    excluded: "Excluded",
    excluded_project_default: "Projects are excluded from providing a health status when the duration of the Project is less than the duration manually specified within the threshold settings.",
    excluded_projects: "Excluded Projects",
    excluded_threshold: "The duration of this mPlan is less than the amount of time specified within the threshold settings.",
    execution_dashboard: "Execution Dashboard",
    existing_files: "Existing Files",
    expected_time: "Expected Time",
    expense_id: "Expense ID",
    expenses: "Expenses",
    expired: "Expired",
    expires: "Expires",
    export: "Export",
    export_all: "Export All Columns",
    export_all_data: "Export All Data",
    export_assignments: "Export Assignments",
    export_calendar_and_schedule: "Export Calendar and Schedule",
    export_columns_selected_or_filtered_grid: "Export Columns as Selected or Filtered in the Grid",
    export_contacts: "Export Contacts",
    export_csv: "Export CSV",
    export_draft: "Export Draft",
    export_excel: "Export Excel",
    export_gallery: "Export Gallery",
    export_item: "Export Item",
    export_location_details: "Export Location Details",
    export_locations: "Export Locations",
    export_notes: "Export Notes",
    export_opportunities: "Export Opportunities",
    export_options: "Export Options",
    export_pdf: "Export PDF",
    export_people: "Export People",
    export_photos: "Export Photos",
    export_powerpoint: "Export Powerpoint",
    export_selected: "Export Columns as Selected or Filtered in the Grid",
    export_selections: "Export Selections",
    export_tags: "Export Tags",
    export_template: "Export Template",
    export_work: "Export Work",
    export_work_bank_visits: "Export Work Bank Visits",
    export_zip: "Export Zip",
    external_project_links: "External Project Links",
    failed: "Failed",
    failed_location_imports: "failed location imports",
    failed_to_update_record: "Failed to update record",
    fails: "Fails",
    feature_preferences: "Feature Preferences",
    features: "Features",
    feb: "Feb",
    feedback: "Feedback",
    field_is_required: "Field is Required.",
    file_attachment: "File Attachment",
    file_name: "File Name",
    file_too_large_20: "File size too large.  Must be less than 20MB.",
    file_uploaded_successfully: "File uploaded successfully",
    file_with_errors_cannot_be_imported_review_information_below: "File with errors cannot be imported. Review information below.",
    files_uploaded: "File(s) Uploaded",
    files_uploaded_successfully: "file(s) uploaded successfully",
    fill_out_the_following_fields_then_click_next: "Fill out the following fields, then click Next.",
    fill_out_the_following_fields_then_click_save: "Fill out the following fields, then click Save.",
    filter_by_assignment_value: "Filter by Assignment Value",
    filter_by_location: "Filter by Location",
    filter_by_person: "Filter by Person",
    filter_by_project_identifiers: "Filter by Project Identifiers",
    filters: "Filters",
    final_recurrence_due: "Final Recurrence Due",
    final_recurrence_due_on: "Final Recurrence Due on:",
    first: "first",
    first_name: "First Name",
    flat_rate: "Flat Rate",
    forklift_certification: "Forklift Certification",
    forward: "Forward",
    forward_message: "Forward Message",
    fourth: "fourth",
    frequency: "Frequency",
    friday: "Friday",
    gallery_name: "Gallery Name",
    gallery_options: "Gallery Options",
    gallery_refreshed: "Gallery Refreshed",
    gallery_refreshing: "Gallery Refreshing",
    general: "General",
    general_information: "General Information",
    general_message: "General Message",
    geographic_radius: "Geographic Radius",
    give_best_experience_enter_the_projects_to_view: "To give you the best experience, you’ll need to enter the projects that you’d like to view",
    give_best_experience_enter_the_rep_to_view: "To give you the best experience, you’ll need to enter the rep that you’d like to view",
    global_dashboards: "Global Dashboards",
    global_reports: "Global Reports",
    go_to_desktop: "Go to Desktop",
    go_to_mobile_site: "Movista Mobile Site",
    great_day: "Have a great day!",
    guid: "GUID",
    guids: "GUIDs",
    half_day: "Half Day",
    half_pie: "Half Pie",
    has_been_sucessfully_deleted: "has been successfully deleted",
    has_been_sucessfully_duplicated: "has been successfully duplicated",
    health: "Health",
    health_overview: "Health Overview",
    hide_infinity: "Hide Infinity",
    hide_insights: "Hide Insights",
    hide_no_response: "Hide No Responses",
    hide_no_responses: "Hide No Responses",
    hide_staff_name: "Hide Staff Name",
    hierarchy: "Hierarchy",
    high: "High",
    high_priority: "High Priority",
    home_address: "Home Address",
    home_phone: "Home Phone",
    hot_tasks: "Hot Tasks",
    hour: "hour",
    hourly: "Hourly",
    hours: "hours",
    hours_option: "Hour(s)",
    how_long_this_project_take_to_complete: "How long should this project take to complete?",
    how_often_should_this_project_be_completed: "How often should this project be completed?",
    how_would_you_like_to_end_this_project: "How would you like to end this project?",
    html_response: "HTML response is invalid.",
    hub: "Hub",
    hundred_percent_submitted: "100% Submitted",
    i_accept: "I Accept",
    i_dont_know_which_login_to_use: "I dont know which login to use",
    i_forgot_my_username_or_password: "I forgot my username or password.",
    ie_android_ios: "i.e. Android, iOS",
    ie_device_os: "ie Device os",
    ie_personal_device_corporate_device: "i.e. Personal Device, Company Device",
    if_work_is_not_submitted_by: "If Work is not Submitted by",
    image_attached: "Image attached",
    image_default_error: "Error uploading image to server",
    image_too_large: "File size too large.  Must be less than 5MB.",
    import: "Import",
    import_a_csv_to_bulk_select_a_set_of_location_numbers: "Import a CSV to bulk select a set of location numbers.",
    import_attributes: "Import Attributes",
    import_error_msg: "Unsupported File Type. Please upload a JPG or PNG file.",
    import_errors: "Import Errors",
    import_invitations: "Import Invitations",
    import_item_updates: "Import Item Updates",
    import_items: "Import Items",
    import_location_data: "Import Location Data",
    import_locations: "Import Locations",
    import_new_locations: "Import New Locations",
    import_preferred_reps: "Import Preferred Reps",
    import_primary_rep_location: "Import Primary Rep Location",
    import_roles: "Import Roles",
    import_schedule: "Import Schedule",
    import_title_tool_tip_text: "The MVIDs of the current items in the Item Set are listed below. To remove an item, set its Action to Remove. To add an item, add its MVID on a new row and set the Action to Add. Items with no Action will not be affected.",
    import_unsuccessful_please_review_errors: "Import Unsuccessful - Please review errors",
    import_update_location_availability: "Import Item Location Availability Updates",
    import_update_location_specific_attributes: "Import Item Location Specific Attributes Updates",
    importing_locations_this_may_take_a_while: "Importing Locations, this may take a while...",
    in_progress: "In Progress",
    inactive: "Inactive",
    inbox: "Inbox",
    include_additional_visit_details: "Include Additional Visit Details",
    include_custom_fields_in_the_template: "Include Custom Fields in the Template",
    include_display_values: "Include Display Values",
    include_reps_who_previously_declined: "Include reps who previously declined",
    include_reps_who_previously_declined_tooltip: "If enabled, reps who previously declined an opportunity will be included in the opportunity selection.",
    include_the_submitted_answers_and_item_count_responses_in_this_reissue: "Include the submitted answers and item count responses in this reissue",
    incomplete_planogram_reasons: "Incomplete Planogram Reasons",
    incomplete_planogram_summary: "Please provide reasoning for not being able to complete the planogram.",
    incorrect_planogram_evaluation: "Incorrect planogram evaluation",
    infinity: "Infinity",
    infinity_mplans_can_be_scheduled_more_than_once: "Infinity mPlans can be scheduled more than once",
    infinity_opportunities_unavailable: "Opportunities are not available with Infinity Projects. To enable Opportunities, change the Project Type to Standard.",
    infinity_project_default: "Projects that have an infinite number of possible visits. These projects will have no health status due to the variability of the project.",
    infinity_projects: "Infinty Projects",
    infinity_projects_support: "Infinity projects support “Due Date” and “Manual” End Type",
    infinity_work_does_not_support_this_feature: "Infinity Work does not support this feature",
    input_type: "Input Type",
    insights: "Insights",
    instructions_title: "Instructions",
    interval: "interval",
    invalid_characters: "Invalid Character(s)",
    invalid_characters_include: "Invalid characters include",
    invalid_date: "Invalid Date",
    invalid_date_range: "Invalid Date Range",
    invalid_email: "Invalid Email",
    invalid_end_time: "Invalid End Time",
    invalid_location_numbers_will_not_be_saved: "Invalid Location Number(s) - will not be saved:",
    invalid_object: "Request Object Invalid",
    invalid_template: "Invalid Template",
    invalid_tooltip: "Entry cannot match another record",
    invalid_url: "Url Invalid",
    invite_from_csv: "Invite From CSV",
    invite_reps: "Invite Reps",
    invite_resend_success_message: "has been sent a new registration code.",
    invited: "Invited",
    invited_on: "Invited On",
    is: "Is",
    is_between: "Is Between",
    is_not: "Is Not",
    is_not_valid: "is not valid",
    issue_overview: "Issue Overview",
    issue_status: "Issue Status",
    item_actions: "Item Actions",
    item_catalog: "Item Catalog",
    item_count: "Item Count",
    item_count_request: "Item Count Request",
    item_count_requests: "Item Count Request",
    item_grid: "Item Grid",
    item_id: "Item ID",
    item_maintenance: "Item Maintenance",
    item_manager: "Item Manager",
    item_out_of_stock: "Item out of stock",
    item_request_manager: "Item Request Manager",
    item_request_name: "Item Request Name",
    item_requests_title: "Item Requests",
    item_set_name: "Item Set Name",
    item_set_template: "Item Set Template",
    item_sets: "Item Sets",
    items: "Items",
    items_added_from_my_tools: "Item(s) Added from \"My Tools\"",
    items_selected: "Items Selected",
    jan: "Jan",
    job: "Job",
    job_code: "Job Code",
    job_id: "Job ID",
    jul: "Jul",
    jun: "Jun",
    keep_typing_to_see_results: "Keep typing to see results",
    language: "Language",
    language_change_alert: "Whoops! There was an error communicating with the server",
    last_30_days: "Last 30 Days",
    last_90_days: "Last 90 Days",
    last_active: "Last Active",
    last_edited: "Last Edited",
    last_edited_by: "Last Edited By",
    last_edited_date: "Last Edited Date",
    last_fourteen_days: "Last 14 Days",
    last_login: "Last Login",
    last_name: "Last Name",
    last_ninety_days: "Last 90 Days",
    last_project_activity: "Last Project Activity",
    last_run: "Last Run",
    last_run_date: "Last Run Date",
    last_seven_days: "Last 7 Days",
    last_thirty_days: "Last 30 Days",
    last_updated_by: "Last Updated By",
    last_updated_on: "Last updated on",
    last_x_days: "Last {number} Days",
    late: "Late",
    late_status: "Late Status",
    latest_start: "Latest Start",
    latestatus_default_details: "The Project will be flagged as Late if every location has not completed and submitted by its due date.",
    latestatus_manual_details: "The Project will be flagged as Late depending on your specifications. This option is useful if you need a Project to be flagged as Late before its due date. Choose the number of days before the due date and submitted percentage threshold you would like the Project to reach or it will be flagged as Late.",
    latitude: "Latitude",
    latitudes: "Latitudes",
    launch: "Launch",
    launch_1hub: " Launch 1Hub",
    launch_amp: "Launch AMP",
    launch_app: "Launch App",
    launch_one: "Launch One",
    left_conversation: "left the conversation",
    legacy_csv: "Legacy CSV",
    legacy_locations_hub: "Legacy Locations Hub",
    legacy_reporting_center: "Legacy Reporting Center",
    less_than: "Less than",
    lets_find_your_items: "Let's Find Your Items",
    lets_find_your_locations: "Let's Find Your Locations",
    lift_fifty_plus: "Lift 50+ LBS",
    limit_any_numeric_entries_in_the_app: "Limit any numeric entries in the app. Values have no limits and can include negative numbers or decimal points.",
    link_name: "Link Name",
    link_status: "Link Status",
    link_url: "Link URL",
    links_added: "Link(s) Added",
    list: "List",
    list_name: "List Name",
    lists: "Lists",
    loading: "loading",
    location: "Location",
    location__s: "Location(s)",
    location_address: "Location Address",
    location_address_two: "Location Address 2",
    location_assigned: "Location Assigned",
    location_assignments: "Location Assignments",
    location_based: "Location Based",
    location_count: "Location Count",
    location_custom_fields: "Location Custom Fields",
    location_details: "Location Details",
    location_id: "Location ID",
    location_ids: "Location IDs",
    location_info: "Location Info",
    location_list: "Location List",
    location_lists: "Location Lists",
    location_mvid: "Location MVID",
    location_name: "Location Name",
    location_number: "Location #",
    location_number_long: "Location Number",
    location_number_text: "Location Number",
    location_numbers: "Location Numbers",
    location_phone_number: "Location Phone Number",
    location_timezone: "Location Timezone",
    locations: "Locations",
    locations_added: "Locations Added",
    locations_and_projects: "Locations & Projects",
    locations_assigned: "Locations Assigned",
    locations_assigned_capitalized: "Locations Assigned",
    locations_edited: "Locations Edited",
    locations_export: "Locations Export",
    locations_hub: "Locations Hub",
    locations_imported: "Locations Imported",
    locations_only: "Locations Only",
    locations_selected: "Locations Selected",
    login: "Login",
    login_id: "Login ID",
    logout: "Sign Out",
    longitude: "Longitude",
    longitudes: "Longitudes",
    looker: "Looker",
    low: "Low",
    low_priority: "Low Priority",
    lsq_tip_no_locations: " In order to assign location specific questions, locations must be added to the project first.",
    lsq_tip_with_locations_end: "Click the button below to specify the locations at which this question is asked.",
    lsq_tip_with_locations_start: "This question will be asked at all locations.",
    lsq_tooltip: "This question is only available at select locations.",
    m_plan_info: "mPlan Info",
    maintain_recurrence_duration: "Maintain Recurrence Duration",
    make_response_visibility_private: "Make Response Visibility Private",
    make_the_question_location_specific: "Make the Question Location-Specific",
    manage_locations: "Manage Locations",
    manage_order: "Manage Order",
    manage_roles: "Manage Roles",
    manage_tools: "Manage Tools",
    management_portal: "Management Portal",
    manager: "Manager",
    manager_email: "Manager Email",
    manager_help: "Select any user you would like to be associated as a manager to this project work for reporting. This entry is optional.",
    manager_info: "Manager Info",
    manager_information: "Manager Information",
    manager_label: "Manager",
    manager_name: "Manager Name",
    manager_phone_number: "Manager Phone Number",
    managers: "Managers",
    managers_login_question_information: "Managers log in credentials are a combination of letters and possibly numbers.",
    managers_only: "Managers Only",
    manual: "Manual",
    manual_entry: "Manual Entry",
    manually_enter_values_to_select_location_numbers: "Manually enter values to make a bulk select a set of location numbers.",
    manufacturer: "Manufacturer",
    manufacturers: "Manufacturers",
    mar: "Mar",
    mark_as_high_priority: "Mark as High Priority",
    marked_complete: "Marked Complete",
    master_question: "Master Question",
    master_questions: "Master Questions",
    max_cannot_be_greater_than_allowed_max: "Maximum value cannot be greater than the parent question's maximum",
    max_cannot_be_less_than_default: "Maximum value cannot be less than the default value.",
    max_custom_fields_reached: "Maximum number of custom fields reached (30).",
    max_daily_hours: "Max Daily Hours",
    max_must_be_greater_than_min: "Maximum value must be greater than the minimum value.",
    max_must_be_greater_than_min_cannot_be_less_than_default: "Maximum value must be greater than minimum value and cannot be less than the default value.",
    max_weekly_hours: "Max Weekly Hours",
    maximum_character_limit_reached: "Maximum character limit reached",
    maximum_value: "Maximum Value",
    maximum_value_also_required: "Maximum value is also required.",
    may: "May",
    media_max: "Max: 20MB",
    media_title: "Media",
    media_types: "BMP, CSV, DOC, DOCX, GIF, HTM, HTML, JPG, JPEG, MOV, MP3, MP4, PNG, PDF, PPT, PPTX, RTF, TXT, WAV, WMV, XLS, XLSX, & ZIP.",
    merchandiser: "Merchandiser",
    message: "Message",
    message_error: "There was an issue sending your message.   Click on the message options to try again.",
    message_group: "Message Group",
    messages: "Messages",
    messaging: "Messaging",
    mileage_comparison: "Mileage Comparison",
    min_cannot_be_greater_than_default: "Minimum value cannot be greater than the default value.",
    min_cannot_be_greater_than_default_must_be_less_than_max: "Minimum value cannot be greater than default value and must be less than maximum value.",
    min_cannot_be_less_than_allowed_min: "Minimum value cannot be less than the parent question's minimum",
    min_must_be_less_than_max: "Minimum value must be less than the maximum value.",
    minimum_age: "Minimum Age",
    minimum_billable_time: "Minimum Billable Time",
    minimum_billable_time_help: "If applicable, enter the minimum billable duration, in minutes, for each work visit submitted, regardless of actual work time.",
    minimum_payable_time: "Minimum Payable Time",
    minimum_payable_time_help: "If applicable, enter the minimum pay duration, in minutes, for each work visit submitted, regardless of actual work time.",
    minimum_value: "Minimum Value",
    minimum_value_also_required: "Minimum value is also required.",
    minutes: "minutes",
    missed: "Missed",
    missing_fixtures: "Missing fixtures",
    missing_skills_and_capabilities: "Missing Skills & Capabilities",
    mm_dd_yy: "MM/DD/YY",
    mm_dd_yyyy: "MM/DD/YYYY",
    mobile: "Mobile",
    mobile_alert: "Send alert if a mobile user",
    mobile_manager_view: "Mobile App - Manager View",
    mobile_phone: "Mobile Phone",
    monday: "Monday",
    month: "month",
    monthly: "Monthly",
    monthly_recurring_end_error: "A monthly recurring that is due on the last day of the month cannot start later than the 27th day of the month.",
    monthly_recurring_error: "A monthly recurring cannot last longer than one month.",
    monthly_recurring_start_error: "A monthly recurring cannot start later than the 28th day of the month.",
    monthly_recurring_week_error: "A monthly recurring cannot end later than the 28th day of the month unless Due on month end is selected.",
    months: "months",
    more_filters: "More Filters",
    movista_inc_all_rights_reserved: "Movista Inc. All rights reserved",
    mplan_details: "mPlan Details",
    mplan_identifier: "mPlan Identifier",
    mplan_name: "mPlan Name",
    mplan_question: "mPlan Question",
    mplan_responses: "mPlan Responses",
    mplan_responses_link: "mPlan Responses Link",
    mplan_status: "mPlan Status",
    mplan_submission_link: "mPlan Submission Link",
    mplan_tags: "mPlan Tags",
    mplan_template_types: "mPlan Template Types",
    mplan_type: "mPlan Type",
    mplans: "mPlans",
    multi_select: "Multi Select",
    multi_select_dash: "Multi-Select",
    multiple_choice: "Multiple Choice",
    must_have_a_survey_with: "must have a survey with",
    mv_id: "MV ID",
    mvid: "MVID",
    mvids: "MVIDs",
    my_tools: "My Tools",
    n_a: "N/A",
    name: "Name",
    needs: "needs",
    needs_configuration: "Needs Configuration",
    needs_review: "Needs Review",
    never: "Never",
    new: "NEW",
    new_activities_next_week: "New activities scheduled for next week",
    new_activities_this_week: "New activities scheduled for this week",
    new_activity_next_week: "New activity scheduled for next week",
    new_activity_scheduled_for: "New activity scheduled for",
    new_attribute: "New Attribute",
    new_custom_field: "New Custom Field",
    new_escalation_alert: "New Escalation Alert",
    new_item_set: "New Item Set",
    new_list: "New List",
    new_message: "New Message",
    new_mplan: "Start New mPlan",
    new_note: "New Note",
    new_range: "New Range",
    new_recurring_event: "New Recurring Event",
    new_response_value: "New Response Value",
    new_section: "New Section",
    new_sub_section: "New Subsection",
    new_value: "New Value",
    next: "Next",
    next_30_days: "Next 30 days",
    next_7_days: "Next 7 Days",
    next_seven_days: "Next 7 Days",
    next_sixty_days: "Next 60 Days",
    no: "No",
    no_active: "No Active",
    no_active_tags: "No Active Tags",
    no_activity_log_found: "No Activity Log Found",
    no_angle_brackets: "No angle brackets",
    no_announcements: "No announcements yet",
    no_attributes: "No Attributes",
    no_clients_found: "No Clients within the defined filters",
    no_conversations: "No conversations yet",
    no_created_templates: "There are no templates created yet",
    no_custom_fields_to_display: "No Custom Fields within the defined filters",
    no_data_available: "No Data Available",
    no_data_found: "No Data within defined filters",
    no_data_in_csv: "No data in CSV",
    no_data_to_be_visualized: "No data available to be visualized",
    no_data_to_display: "No data to display",
    no_description: "-",
    no_display_text: "Response Option Text - Planogram Not Completed",
    no_drafts: "No drafts yet",
    no_end_date: "No end date",
    no_existing_files_uploaded: "No Existing Files have been uploaded",
    no_existing_item_requests: "There are no existing Item Requests.",
    no_filtered_results: "No results within the defined filters.",
    no_inactive_reps_to_display: "No Inactive Reps to display",
    no_instructions: "There are no Instructions for this project.",
    no_invited_reps_from_filter: "No one within the defined filter",
    no_invited_reps_from_filter_body: "Please adjust search to populate data or ",
    no_invited_reps_to_display: "No staff to display",
    no_item_sets: "No Item Sets",
    no_item_sets_found: "No Item Sets Found",
    no_items_found: "No Items Found",
    no_items_selected: "No Items Selected",
    no_items_to_display: "No Items To Display",
    no_lists_found: "No Lists within the defined filters",
    no_lists_to_display: "No Lists to display",
    no_location_found: "No Locations within the defined filters",
    no_locations_to_display: "No Locations to display",
    no_matches_based_on_opportunity_parameters_and_staff_requirements: "No matches based on Parameters and Requirements, please adjust your selection.",
    no_media: "Media has not been added to this work yet.",
    no_notes_created: "No notes have been created yet.",
    no_options_available: "No Options Available",
    no_people_found: "No people found",
    no_priority: "No Priority",
    no_project_found: "No Projects within defined filters",
    no_projects_to_display: "No Projects to Display",
    no_rep_found: "No rep within the defined filters",
    no_report_found: "No Reports within defined filters",
    no_reports_available: "No Reports Available",
    no_reps_to_display: "No Reps to display",
    no_response_options: "There are no response options for this question type.",
    no_response_received: "No Server Response",
    no_responses: "No Responses",
    no_results: "No Results",
    no_results_found: "No Results Found",
    no_roles: "No Roles",
    no_sales_media_uploaded: "No Sales Media has been uploaded",
    no_score_value: "\"No\" Score Value",
    no_section: "No Section",
    no_selection: "No Selection",
    no_sent_announcements: "No sent announcements yet",
    no_staff_available_within_the_selected_filters: "No staff available within the selected filters",
    no_store_name: "No Store Name",
    no_stores_assigned: "No Stores Assigned",
    no_submitted_response: "Submitted No Response",
    no_supervisor_assigned: "No supervisors have been assigned to this person yet.",
    no_survey_text: "There are no survey questions created for this work yet.",
    no_tags_found: "No Tags Found",
    no_tools: "Tools has not been added to this work yet.",
    no_value_for: "No value for",
    no_visit_details_found: "No Visit Details Found",
    no_work_available: "No work available",
    non_location_specific_question: "non-location specific question",
    non_staffed_projects: "Unstaffed Projects",
    non_standard: "Non Standard",
    none: "None",
    none_selected: "None Selected",
    normal: "Normal",
    normal_priority: "Normal Priority",
    not_clocked_in: "Not Clocked In",
    not_permitted_in_report: "You do not have permission to view this report.",
    not_submitted: "Not Submitted",
    not_valid_characters: "are not valid file name characters",
    note: "Note",
    notes: "Notes",
    nothing_to_select: "Nothing to Select",
    nov: "Nov",
    number: "Number",
    number_marked_complete: "# Marked Complete",
    number_of_locations: "Number of Locations",
    number_of_occurrence: "# of Occurrences",
    number_of_responses: "Number of Responses",
    number_of_visits: "Number of Visits",
    number_scheduled: "# Scheduled",
    number_submitted: "# Submitted",
    numeric: "Numeric",
    occurrence: "occurrence",
    occurrences: "occurrences",
    occurs_every: "Occurs every",
    occurs_everyday: "Occurs everyday",
    oct: "Oct",
    of: "of",
    ok: "OK",
    on: "on",
    on_mplan: "Working on mPlan",
    on_row: "on row",
    on_this_day: "On this day",
    on_time: "On Time",
    on_track: "On track",
    on_track_projects: "On Track Projects",
    once: "Once",
    once_a_photo_is_removed_it_cannot_be_added_again: "Once a photo is removed, it cannot be added again.",
    once_scheduled_only_staff: "Once scheduled, only scheduled staff can see this work",
    once_the_survey_is_saved_this_action_cannot_be_undone: "Once the survey is saved, this action cannot be undone.",
    one_by_movista: "ONE by Movista",
    onehub_by_movista: "1Hub by Movista",
    only_you_can_see_this: "Only you will see the name of this event.",
    ontrack_project_default: "Projects that are within the specified day and percentage threshold and are anticipated to be completed on time.",
    open: "Open",
    open_visits: "Open Visits",
    open_visits_tooltip: "A visit that has no Opportunities available and is not scheduled",
    opportunities: "Opportunities",
    opportunities_created: "Opportunities Created",
    opportunities_exist: "Opportunities Exist",
    opportunities_parameters: "Opportunities Parameters",
    opportunity_parameters: "Opportunity Parameters",
    optional: "Optional",
    optional_rep_is_automatically_notified_by_email: "Optional, Rep is automatically notified by email.",
    options: "Options",
    or: " or",
    order_information: "Order Information",
    original: "Original",
    original_file_name: "Original File Name",
    other: "Other",
    out_of: "out of",
    outside_agency: "Outside Agency",
    outside_start_date_requirement: "Outside Start Date Requirement",
    outside_start_time_requirement: "Outside Start Time Requirement",
    overlapping_visits: "Overlapping Visits",
    overlapping_visits_created_review_below: "Overlapping visits created. Review below and import updates if needed.",
    overlapping_visits_validation_error: "Unable to Schedule Visit because of Overlapping Schedule.",
    owner: "Owner",
    page: "Page",
    parent_tag: "Parent Tag",
    partial_opportunities_created: "Partial Opportunities Created",
    partial_opportunities_open_visit_tool_tip_begin: "Unable to generate Opportunities for",
    partial_opportunities_open_visit_tool_tip_end: "visits based on Parameters and Staff Requirement selections.",
    partial_opportunities_warning: "visits don't have matches based on Parameters and Requirements selection.",
    pass_fail_based_percent: "Pass/Fail Based on Percent",
    pass_fail_based_percent_help: "Select this option to add a required percentage score to a scored project survey.",
    pass_fail_email_alert: "Pass/Fail Email Alert",
    pass_fail_email_alert_help: "Select this option to send email alerts for each scored survey submission.",
    passed: "Passed",
    passes: "Passes",
    passing_percentage: "Passing Percentage",
    passing_percentage_error: "Passing percentage must be between 1 and 100",
    password: "Password",
    password_recovery_sentence: "Enter your email address. We will email you a link with instructions for recovering your username or password.",
    pause: "Pause",
    paused: "Paused",
    paused_reason: "Paused Reason",
    paused_reason_note: "Paused Reason Note",
    pay: "Pay",
    pay_rate: "Pay Rate",
    pay_rate_help: "Enter the project staff pay rate based on your pay type selection.",
    pay_rate_in_dollars: "Pay Rate (dollars)",
    pay_type: "Pay Type",
    pay_type_help_flat: "Staff pay based on a fixed amount for each work submission.",
    pay_type_help_hourly: "Staff pay based on hours worked.",
    pay_type_help_none: "Staff pay amounts not tracked.",
    pay_type_help_title: "Pay Type selection determines the method of staff pay for the project work:",
    payroll: "Payroll",
    payroll_and_expenses: "Payroll & Expenses",
    pending: "Pending",
    pending_approval: "Pending Approval",
    pending_projects: "Pending Projects",
    pending_projects_default: "Projects that have been created and published with a date in the future. These projects will not provide a health status because they have not yet begun.",
    people: "People",
    people_attributes: "People Attributes",
    people_hub: "People Hub",
    percent_marked_complete: "% Marked Complete",
    percent_needed_to_pass: "Percent Needed to Pass",
    percent_scheduled: "% Scheduled",
    percent_submitted: "% Submitted",
    percentage_needed_to_pass: "Percentage Needed to Pass",
    person: "Person",
    person_unavailable: "Person Unavailable",
    personal_info: "Personal Info",
    personal_information: "Personal Information",
    phone_number: "Phone Number",
    phone_number_error: "Invalid character entered. Valid characters include numeric and + x - ( )",
    phone_numbers: "Phone Numbers",
    photo_galleries: "Photo Galleries",
    photos: "Photos",
    pie: "Pie",
    planning: "Planning",
    planogram_completion: "Planogram Completion",
    planogram_scoring: "Planogram Scoring",
    platform_availability: "Platform Availability",
    please_add_additional_search_criteria_to_limit_your_search: "Please add additional search criteria to limit your search",
    please_add_one_or_more_response_values: "Please add one or more response values.",
    please_address_the_active_question_first: "Please address the active question first.",
    please_adjust_the_filter_set: "Please adjust the filter set",
    please_adjust_the_filter_set_or: "Please adjust the filter set or",
    please_adjust_this_filter: "Please adjust this filter.",
    please_assign_a_rep_and_enter_a_start_date_and_time: "Please assign a Rep and enter a start date and time.",
    please_assign_staff_date_and_time: "Please assign a Staff, enter the Date and Time",
    please_create_report: "Please create a report",
    please_ensure_all_scored_values_are_in_range: "Please ensure all scored values are in range",
    please_ensure_all_values_are_in_range: "Please ensure all values are in range.",
    please_enter_correct_url_format: "Please enter a correct url format that contain \"https://\" or \"http://\"",
    please_fill_in_the_complete_details_to_confirm: "Please fill in the complete details to confirm.",
    please_provide_an_estimated_time_this_determines_the_duration_of_the_event: "Please provide an Estimated Time. This determines the duration of the event.",
    please_remove_all_attributes_in_this_subsection_before_deleting: "Please remove all attributes in this subsection before deleting.",
    please_select_a_condition_in_conditional_logic: "Please select a condition in Conditional Logic.",
    please_select_a_value_for: "Please select a value for",
    please_select_one_visit_row: "Please select at least one visit/row to include",
    please_upload_files_within_uploaded_files: "Please upload files within the \"Uploaded Files\" tab",
    please_upload_media_from_tools_page: "Please upload sales media from the \"Tools\" page",
    please_verify_that_any_child_questions: "Please verify that any child questions still have valid dependent answers, otherwise they may no longer appear.",
    portal: "Portal",
    postal_code: "Postal Code",
    postal_codes: "Postal Codes",
    powered_by_movista: "Powered by Movista, Inc.",
    preference_management_tool: "Preference Management Tool",
    preferences: "Preferences",
    preferred: "Preferred",
    preferred_reps: "Preferred Reps",
    preferred_reps_imported: "Preferred Reps Imported",
    preparing_reports: "Preparing Reports",
    press: "Press",
    press_the: "Press the",
    prevent_work_from_being_started: "Prevent work from being started before specified time",
    prevent_work_from_being_started_after: "Prevent work from being started after specified time",
    previous: "Previous",
    primary_contact_email: "Contact E-mail",
    primary_contact_name: "Main Contact 1",
    primary_contact_phone: "Contact Phone Number",
    primary_location: "Primary Location",
    primary_rep_locations: "Primary Rep Locations",
    primary_rep_locations_imported: "Primary Rep Locations Imported",
    print: "Print",
    prior_next_30_days: "Prior/Next 30 days",
    prior_year_next_30_days: "Prior Year/Next 30 Days",
    priority: "Priority",
    priority_help: "Select a priority value to associate with this project work. This entry is optional.",
    priority_label: "Priority",
    privacy_policy: "Privacy Policy",
    private: "Private",
    process_only_open_visits: "process ONLY open visits",
    profile: "Profile",
    project: "Project",
    project_based: "Project Based",
    project_count: "Project Count",
    project_date_s: "Project Date(s)",
    project_dates: "Project Dates",
    project_drafts: "Project Drafts",
    project_due: "Project Due",
    project_due_date: "Project Due Date",
    project_due_date_time: "Project Due Date & Time",
    project_end: "Project End",
    project_end_type_due_date: "DUE DATE: This project will end at 00:01 on the selected due date.",
    project_end_type_manual: "MANUAL: This project will only end when it has been manually selected to end.",
    project_end_type_submitted: "100% SUBMITTED: This project will end once all visits have been submitted in the app.",
    project_id: "Project ID",
    project_list: "Project List",
    project_name: "Project Name",
    project_number: "Client Project #",
    project_number_text: "Client Project #",
    project_overview: "Project Overview",
    project_published: "Project Published",
    project_reference_number: "Project Reference Number",
    project_required_to_be_scheduled: "If this project is required to be scheduled, “Estimated Time” must be greater than 0 Minutes.",
    project_start: "Project Start",
    project_start_date: "Project Start Date",
    project_start_date_time: "Project Start Date & Time",
    project_status: "Project Status",
    project_template_types: "Project Template Types",
    project_templates: "Project Templates",
    project_type: "Project Type",
    projected_to_be_late: "Projected to be Late",
    projects: "Projects",
    projects_due: "Projects due",
    projects_due_on: "Projects due on",
    projects_not_submitted: "Projects Not Submitted",
    projects_selected: "Projects Selected",
    provider_type: "Provider Type",
    province: "Province",
    provinces: "Provinces",
    public: "Public",
    publish: "Publish",
    publish_changes: "Publish Changes",
    publish_draft_body: "Activating a Project allows people using the mobile app to view the Project. This action cannot be undone.",
    qualified_reps: "Qualified Reps",
    qualified_staff_regardless_of_scheduling: "Qualified staff can see this work regardless of scheduling",
    qualified_staff_until_scheduled: "Qualified staff cannot see this work until it is scheduled",
    question_deleted: "Question Deleted",
    question_duplicated: "Question Duplicated",
    question_header: "Question Header",
    question_header_required: "Question Header Required",
    question_s: "Question(s)",
    question_settings: "Question Settings",
    question_text: "Question Text",
    question_type: "Question Type",
    quick_select: "Quick Select",
    quick_select_locations: "Quick Select Locations",
    ran_out_of_time: "Ran out of time",
    range: "Range",
    reactivate_success: "is now active.",
    reactivate_tag: "Reactivate Tag",
    ready: "Ready",
    reasons: "Reasons",
    recalculate: "Recalculate",
    recalculation_successful: "Recalculation Successful",
    recently_used: "Recently Used",
    recipient: "Recipient",
    recipients: "Recipients",
    recurrence_due: "Recurrence Due",
    recurrence_due_date: "Recurrence Due Date",
    recurrence_due_date_help: "Default due date of the project recurrence ends at 00:01 on the selected date. Set another defined due time if the latest start time of the work should be earlier in the mobile app.",
    recurrence_due_date_time: "Recurrence Due Date & Time",
    recurrence_end: "Recurrence End",
    recurrence_error: "Unable to retrieve recurrence information.  Please try again later.",
    recurrence_project_help: "Recurring projects support only the “Due Date” End Type",
    recurrence_start: "Recurrence Start",
    recurrence_start_date: "Recurrence Start Date",
    recurrence_start_date_help: "Default start time of the project recurrence begins at 00:01 on the selected date. Set another defined start time if the work should start later in the mobile app.",
    recurrence_start_date_time: "Recurrence Start Date & Time",
    recurring_count_error: "Please enter the number of times (more than zero) this will repeat.",
    recurring_end_help: "Select when the project should stop recurring. Default is never stop recurring.",
    recurring_events: "Recurring Events",
    recurs: "Recurs",
    recurs_indefinitely: "Recurs indefinitely",
    recurs_until: "Recurs until",
    reference_number: "Ref. #",
    refresh: "Refresh",
    refresh_data: "Refresh Data",
    register_a_rep: "Register A Rep",
    register_with_movista: "Activate With Movista",
    registered_user_subscription_agreement: "Registered User Subscription Agreement",
    regular: "Regular",
    reissue: "Reissue",
    reissue_cancelled: "Reissue Cancelled",
    reissue_expiration_date: "Reissue Expiration Date",
    reissue_to: "Reissue to",
    reissued: "Reissued",
    reissuing_allows_this_visit_to_be_submitted_again_at_this_location: "Reissuing allows this visit to be submitted again at this location",
    relative_estimates: "Relative Estimates",
    remaining: "remaining",
    remove: "Remove",
    remove_acknowledgment: "Remove Acknowledgment",
    remove_attachment: "Remove Attachment",
    remove_event: "Remove Event",
    remove_from_app_if_marked_complete: "Remove from app if marked complete",
    remove_from_app_if_marked_complete_help: "After Infinity work is submitted and marked as complete in the app, the work will be removed from view for staff.",
    remove_from_gallery: "Remove from Gallery",
    remove_high_priority: "Remove High Priority",
    remove_photos: "Remove Photos",
    remove_visit_details: "Remove Visit Details",
    removed_from_list: "removed from List",
    rep: "Rep",
    rep_details: "Rep Details",
    rep_employee_id: "Rep Employee ID",
    rep_has_been_invited: "Rep Has Been Invited",
    rep_hub: "Rep Hub",
    rep_id: "Rep ID",
    rep_info: "Rep Info",
    rep_name: "Rep Name",
    rep_profile: "Rep Profile",
    rep_readd_end: "They will have access to the Movista mobile app according to their current assignments.",
    rep_readd_middle: "will inform them that they have been selected to work for",
    rep_readd_start: "Activating",
    rep_reported_miles: "Rep Reported Miles",
    rep_type: "Rep Type",
    rep_types: "Rep Types",
    repeat: "Repeat",
    repeat_on: "Repeat On",
    report_builder: "Report Builder",
    report_category: "Report Category",
    report_deleted: "Report Deleted",
    report_details: "Report Details",
    report_name: "Report Name",
    report_shared_successfully: "Report shared successfully",
    report_template: "Report Template",
    report_type: "Report Type",
    reported_miles_status: "Reported Miles Status",
    reporting_center: "Reporting Center",
    reporting_values: "Reporting Values",
    reports: "Reports",
    reports_ready: "Reports Ready",
    reps: "Reps",
    reps_login_question_information: "Reps only have numeric login credentials. To log in to the portal, use the same phone number and pin that you use to log in to the app.",
    reps_not_qualified: "Reps not Qualified",
    reps_selected: "Reps Selected",
    request_photo: "Request Photo(s)",
    request_setup_failed: "Request Setup Failed",
    request_signature: "Request Signature(s)",
    require_acknowledgement: "Require Acknowledgement",
    require_acknowledgment: "Require Acknowledgment",
    require_this_project_to_be_scheduled: "Require this project to be scheduled",
    required: "Required",
    required_upper: "REQUIRED",
    reschedule: "Reschedule",
    reschedule_visit: "Reschedule Visit",
    reschedule_visits: "Reschedule Visit",
    resend: "Resend",
    reset: "Reset",
    reset_filters: "Reset Filters",
    reset_filters_to_default: "Reset filters to default.",
    reset_to_default: "reset filters to default",
    response: "Response",
    response_options: "Response Options",
    response_points: "Response Points",
    response_summary: "Follow-up Question Text - Reasons for Planogram Not Completed",
    response_type: "Response Type",
    response_type_help: "Select the response type you plan to use for your survey questions. Choose \"Standard\" if you do not plan to apply any scores to your questions.",
    response_values: "Response Values",
    response_visibility: "Response Visibility",
    response_visibility_help: "Enabling this feature will set the project to Private, so that app users cannot see responses left by others in the mobile app.",
    result: "Result",
    result_too_large: "Result count is too large.  Please adjust or",
    result_too_large_adjust: "Result count is too large. Please adjust filters.",
    results: "Results",
    retail_details: "Retail Details",
    retailer: "Retailer",
    retailer_name: "Retailer Name",
    retailers: "Retailers",
    retry: "Retry",
    retry_sending: "Retry Sending",
    review: "Review",
    review_warnings_below_and_import_updates_if_needed: "Review warnings below and import updates if needed.",
    role__s: "Role(s)",
    roles: "Roles",
    roles_assigned: "Roles Assigned",
    role_assignments: "Role Assignments",
    route_drive_time_minutes: "Route Drive Time (minutes)",
    route_mileage_tracking: "Use Route Mileage Tracking",
    route_mileage_tracking_help: "Manage whether staff routes are monitored while traveling to each work location. If enabled, actual staff driving routes are compared to the ideal driving route. By default, Route Mileage Tracking is enabled.",
    route_miles: "Route Miles",
    route_rep_reported_variance: "Route/Rep Reported Variance",
    routing_and_mileage_comparison: "Routing and Mileage Comparison",
    row: "Row",
    run: "Run",
    run_dashboard: "Run Dashboard",
    run_report: "Run Report",
    running: "Running",
    running_behind: "Running behind",
    running_behind_project_default: "Projects that are behind the specified day and percentage thresholdand may have some risk to be completed on time.",
    running_behind_projects: "Running Behind Projects",
    saturday: "Saturday",
    save: "Save",
    save_and_continue: "Save & Continue",
    save_as: "Save As",
    save_as_draft: "Save as Draft",
    save_as_pdf: "Save as PDF",
    save_assignment: "Save Assignment",
    save_assignments: "Save Assignments",
    save_changes: "Save Changes",
    save_disabled: "Save disabled, no angle brackets.",
    save_draft: "Save Draft",
    save_print: "Save/Print",
    save_selections: "Save Selections",
    save_successful: "Save Successful",
    save_survey: "Save Survey",
    scatter: "Scatter",
    schedule: "Schedule",
    schedule_and_assign: "Schedule & Assign",
    schedule_date: "Schedule Date",
    schedule_date_time: "Schedule Date/Time",
    schedule_overview: "Schedule Overview",
    schedule_status: "Schedule Status",
    schedule_this_visit: "Schedule this visit",
    schedule_time: "Schedule Time",
    schedule_visit: "Schedule Visit",
    scheduled: "Scheduled",
    scheduled_date: "Scheduled Date",
    scheduled_rep: "Scheduled Rep",
    scheduled_rep_time_manager: "Scheduled Rep Time Manager",
    scheduled_rep_type: "Scheduled Rep Type",
    scheduled_time: "Scheduled Time",
    scheduled_visit: "Scheduled Visit",
    scheduled_visits: "Scheduled Visits",
    scheduled_visits_tooltip: "A visit that is scheduled to a single staff on a specific date and time",
    scheduling: "Scheduling",
    scheduling_config: "Scheduling Configuration",
    scheduling_details: "Scheduling Details",
    scheduling_in_est: "Scheduling in EST",
    scheduling_permissions: "Scheduling Permissions",
    scheduling_permissions_help: "Manage who is allowed to schedule work. Also, manage when staff can view scheduled work in the app.",
    scheduling_times_in: "Scheduling times in",
    scheduling_visibility: "Scheduling Visibility",
    score_only: "Score Only",
    score_only_help: "Hide detailed ShelfCheck results",
    score_percentage: "Score Percentage",
    score_ranges: "Score Ranges",
    score_status: "Score Status",
    scored: "Scored",
    scored_question_label: "Scored Question Label",
    scored_response_type_details: "Scored Response Type Details",
    search: "Search",
    search_alert_circle_icon: "search alert circle icon",
    search_assigner: "Search Assigner",
    search_attributes: "Search Attributes",
    search_city: "Search City",
    search_clients: "Search Clients",
    search_close_icon: "Search Close Icon",
    search_columns: "Search Columns",
    search_current_location: "Search Current Location",
    search_email: "Search Email",
    search_employee_id: "Search Employee IDs",
    search_for_galleries_error: "Please enter 3 or more characters to search for galleries",
    search_for_people: "Search for people",
    search_for_staff: "Search for Staff",
    search_for_work: "Search for work",
    search_item_sets: "Search Item Sets",
    search_items: "Search Item Requests",
    search_last_active: "Search Last Active",
    search_last_project_activity: "Search Last Project Activity",
    search_managers: "Search Managers",
    search_messages: "Search Messages",
    search_mobile_phone: "Search Phone Number",
    search_more_filters: "Search More Filters",
    search_name: "Search Names",
    search_open_icon: "Search Open Icon",
    search_project_names: "Search Project Names",
    search_projects: "Search Projects",
    search_rep_names: "Search Rep Names",
    search_rep_types: "Search Rep Types",
    search_results: "Search Results",
    search_retailers: "Search Retailers",
    search_roles: "Search Roles",
    search_staff: "Search Staff",
    search_state: "Search State",
    search_status: "Search Status",
    search_supervisor: "Search Supervisor",
    search_supervisors: "Search Supervisor(s)",
    search_tags: "Search Tags",
    search_time_manager: "Search Time Managers",
    search_timezone: "Search Timezone",
    search_zero: "Your search returned 0 results",
    second: "second",
    secondary_contact_email: "Contact E-mail",
    secondary_contact_name: "Main Contact 2",
    secondary_contact_phone: "Contact Phone Number",
    seconds: "seconds",
    section: "Section",
    section_details: "Section Details",
    section_name: "Section Name",
    sections: "Sections",
    select_a_question: "Select a Question",
    select_a_response_option: "Select a Response Option",
    select_a_scene: "Select a Scene",
    select_a_sub_scene: "Select a Sub Scene",
    select_a_tool: "Select a Tool",
    select_all: "Select All",
    select_all_that_apply: "Select all that apply",
    select_date_range: "Select Date Range",
    select_individual_unqualified_reps: "Select Individual Unqualified Reps",
    select_item_requests_to_add: "Select any item requests that you’d like to add to this work.",
    select_item_sets_to_add_to_this_project: "Select the Item Set you want to apply to the question.",
    select_list_to_delete: "Please Select A List",
    select_location: "Select Location",
    select_location_lists: "Select Location Lists",
    select_locations_report: "Select the locations you want to include in this report.",
    select_opportunity_create_date_export: "Select Opportunity Creation Date(s) to Export",
    select_parameters: "Select Parameters",
    select_recipients: "Select Recipients",
    select_reps_to_decommission: "Select Reps to Decommission",
    select_staff: "Select Staff",
    select_staff_projects: "Select Staff & Project",
    select_staff_requirements: "Select Staff Requirements",
    select_which_days_should_also_have_this_schedule: "Select which days should also have this schedule",
    selected: "Selected",
    selected_parameters: "Selected Parameters",
    selections_saved: "Selections Saved",
    send_alert_mobile: "Send Alert if a Mobile User",
    send_connection_request: "Send Connection Request",
    send_email: "Send Email",
    send_escalation_alert_to: "Send Escalation Alert to",
    send_exchange_request: "Send Exchange Request",
    send_invitation: "Send Invitation",
    send_request: "Send Request",
    sending_response_email: "You are sending an email containing the responses submitted at",
    sent: "Sent",
    sep: "Sep",
    set_a_due_time: "Set a Due Time for this project",
    set_activated: "Activate Successful",
    set_create_success: "New item set created successfully",
    set_deactivated: "Deactivate Successful",
    set_start_time_for_project: "Set a Start Time for this project",
    set_updated: "Set Updated",
    settings_title: "Settings",
    share: "Share",
    share_link: "Share Link",
    share_type: "Share Type",
    share_update_tooltip: "When this option is selected, recipients can click Refresh to get the most up-to-date report data. The data will be refreshed for all recipients. If recipients cannot refresh report data, they only have access to a static snapshot of the report from the date and time that you shared it.",
    shared_by: "Shared By",
    shared_with: "Shared With",
    shelf_check_warning: "ShelfCheck questions only support 'Single Select' response type",
    shipment_description: "Shipment Description",
    shipped_to: "Shipped To",
    shipping_address: "Shipping Address",
    shipping_and_primary_location: "Shipping & Primary Location",
    show_historical_responses: "Show Historical Responses",
    show_infinity: "Show Infinity",
    show_insights: "Show Insights",
    show_no_response: "Show No Responses",
    show_no_responses: "Show No Responses",
    show_qualified_staff_only: "Show Qualified Staff Only",
    show_this_question_if_response_to: "Show this question if the response to",
    showing_truncated: " total results. Displaying Max ",
    shown: "Shown",
    similar_client_title: "Possible Existing Client",
    similar_entry_title: "Possible Existing Value",
    similar_entry_tooltip: "Existing Values with Similar Text",
    single_select: "Single Select",
    single_sign_on_allows_you_to_log_in: "Single sign-on allows you to log in using your organization's identity provider.",
    skills_and_capabilities: "Skills And Capabilities",
    skills_capabilities: "Skills & Capabilities",
    some_time: "Need some time to think on it?",
    sort: "Sort",
    special_characters: "Special Characters:",
    staff: "Staff",
    staff_activity: "Staff Activity",
    staff_and_manager: "Staff and Manager",
    staff_based: "Staff Based",
    staff_email: "Staff Email",
    staff_hierarchy: "Staff Hierarchy",
    staff_id: "Staff ID",
    staff_name: "Staff Name",
    staff_not_qualified_for_this_visit: "staff not qualified for this Visit",
    staff_phone_number: "Staff Phone Number",
    staff_requirements: "Staff Requirements",
    staff_selected: "Staff Selected",
    staff_type: "Staff Type",
    staff_types: "Staff Types",
    staff_with_opportunity: "Staff with Opportunity",
    staff_without_opportunity: "Staff without Opportunity",
    staffed: "Staffed",
    staffed_projects: "Staffed Projects",
    staffed_projects_tooltip: "Create visit escalation alerts to be sent based any staff assigned to project visits.",
    staffed_projects_tooltip_second_text: "Visits must be assigned and a supervisor hierarchy properly in place.",
    standard: "Standard",
    standard_attributes: "Standard Attributes",
    standard_hours: "Standard Hours",
    start: "Start",
    start_date: "Start Date",
    start_date_explanation: "Use the start date of the project",
    start_date_help: "Default start time of the project begins at 00:01 on the selected date. Set another defined start time if the work should start later in the mobile app.",
    start_date_time: "Start Date/Time",
    start_dates: "Start Date(s)",
    start_due_error: "Start date must be before the due date.",
    start_due_time_error: "Start Time cannot be the same or later than the Due Time.",
    start_is_required: "Start Date is required.",
    start_message: "Start Message",
    start_time: "Start Time",
    start_time_is_required: "Start Time is required.",
    start_typing_to_see_results: "Start typing to see results",
    started: "Started",
    state: "State",
    state_province: "State/Province",
    states: "States",
    status: "Status",
    status_code: "Status Code",
    status_legend: "Status Legend",
    status_overview_chart_title: "Status Overview",
    status_updated: "Status Updated",
    stop_recurring: "Stop Recurring",
    store: "Store",
    store_details: "Store Details",
    store_name: "Store Name",
    store_names: "Store Names",
    store_number: "Store Number",
    store_number_hash: "Store #",
    store_numbers: "Store Numbers",
    store_time: "Store Time",
    stores: "Stores",
    stores__default: "Locations (A - Z)",
    stores__number: "Locations (#)",
    stores__zip: "Zip Codes",
    street_1: "Street 1",
    street_2: "Street 2",
    sub_sections: "Subsections",
    submission_date: "Submission Date",
    submission_details: "Submission Details",
    submission_overview: "Submission Overview",
    submission_source: "Submission Source",
    submission_status: "Submission Status",
    submission_time: "Submission Time",
    submit: "Submit",
    submitted: "Submitted",
    submitted_date: "Submitted Date",
    submitted_end_date: "Submitted End Date",
    submitted_end_time: "Submitted End Time",
    submitted_no_answers: "Submitted No Answers",
    submitted_on: "Submitted on",
    submitted_projects: "Submitted Projects",
    submitted_rep: "Submitted Rep",
    submitted_rep_time_manager: "Submitted Rep Time Manager",
    submitted_rep_type: "Submitted Rep Type",
    submitted_staff: "Submitted Staff",
    submitted_time: "Submitted Time",
    submitted_without_responses: "Submitted without Responses",
    success_invitation_details_have_been_sent: "Success - Invitation details have been sent.",
    success_invitation_details_have_been_sent_to: "Success - Invitation details have been sent to: ",
    successfully_confirmed: "Successfully Confirmed",
    successfully_copied_all: "Successfully Duplicated All",
    successfully_created: "Successfully Created",
    successfully_deleted: "Successfully Deleted",
    successfully_imported_list: "Successfully Imported List",
    successfully_published_changes: "Successfully Published Changes",
    successfully_updated: "Successfully Updated",
    summary: "Summary",
    sunday: "Sunday",
    supervisor: "Supervisor",
    supervisors: "Supervisor(s)",
    supplier: "Supplier",
    support: "Support",
    supports_diff_image_types: "Supports: JPG, PNG, JPEG",
    supports_diff_media_types: "Supports: BMP, CSV, DOC, DOCX, GIF, HTM, HTML, JPG, JPEG, MOV, MP3, MP4, PNG, PDF, PPT, PPTX, RTF, TXT, WAV, WMV, XLS, XLSX, & ZIP",
    survey_builder_conditional_logic_info: "Adding Display Logic will move the current question below the selected parent question in the question list.",
    survey_builder_conditional_tag_info: "If the parent question has tags, they will also be added to this question.",
    survey_builder_unsaved_changes: "You have unsaved changes. Are you sure you wish to continue?",
    survey_date: "Survey Date",
    survey_isq_sub_header: "Add an Item Set to get item-specific answers to this question.",
    survey_isq_tool_tip: "When an item set is added to a question, the rep can answer the question separately for each item in the set. Items will only be shown at locations for which they are authorized.",
    survey_lsq_sub_header: "If no location list is selected, the question will be shown at all locations.",
    survey_lsq_tool_tip: "When a question is location-specific, it will only be shown to the mobile user when they are answering this survey at one of the selected locations.",
    survey_not_found: "Survey Not Found",
    survey_title: "Survey Questions",
    tag_manager: "Tag Manager",
    tag_mvid: "Tag MVID",
    tag_name: "Tag Name",
    tag_status_updated: "Tag Status Updated",
    tag_type: "Tag Type",
    tags: "Tags",
    template_name: "Template Name",
    template_type: "Template Type",
    template_type_help_1: "Select from existing Template Types to add an attribute label that enhances organization of any project template.",
    template_type_help_2: "Template Types are created and managed within Admin Settings.",
    templates: "Templates",
    terms_of_use: "Terms of Use",
    text: "Text",
    text_entry: "Text Entry",
    the_selected_filters: "the selected filters",
    the_submitted_rep: "The submitted rep",
    there_are_no_assignments_set_for_this_project: "There are no assignments set for this project",
    there_are_no_attributes_assigned: "There are no attributes assigned to this staff member.",
    there_are_no_item_requests_selected_for_this_project: "There are no Item Requests selected for this project.",
    there_are_no_opportunities: "There are no opportunities created for this project.",
    third: "third",
    this_action_cannot_be_undone: "This action cannot be undone.",
    this_action_will_undo_all_unsaved_changes_to_the_survey_this_action_cannot_be_undone: "This action will undo all unsaved changes to the survey. This action cannot be undone.",
    this_deletes_it_for_everyone_and_cannot_be_undone_it_can_not_be_restored: "This deletes it for everyone and cannot be undone. It can not be restored",
    this_feedback_is_seen_by_reps: "This feedback is seen by reps",
    this_field_is_required: "This field is required",
    this_mplan_cannot_be_reissued_at_this_location: "This mPlan cannot be reissued at this location",
    this_mplan_was_not_submitted_by_any_rep: "This mPlan was not submitted by any rep",
    this_mplan_was_submitted_by: "This mPlan was submitted by",
    this_person_is_missing_required_skills_and_capabilities: "This person is missing required skills & capabilities",
    this_question_must_contain_text: "This question must contain text.",
    this_question_only: "This Question Only",
    this_report_contains_too_many_results_delete_it: "This report contains too many results. Please delete this report from the ",
    this_section_cannot_be_deleted_please_remove_all_attributes_in_this_section_before_deleting: "This section cannot be deleted. Please remove all attributes in this section before deleting",
    this_visit_cannot_be_scheduled_after_the_latest_available_date_of: "This visit cannot be scheduled after the latest available date of",
    this_visit_cannot_be_scheduled_prior_to_the_current_date_time: "This visit cannot be scheduled prior to the current date and time",
    this_visit_cannot_be_scheduled_prior_to_the_earliest_available_date_of: "This visit cannot be scheduled prior to the earliest available date of",
    this_visit_overlaps_with_an_existing_event: "This visit overlaps an existing event",
    this_visit_overlaps_with_another_event: "The visit overlaps with another event",
    this_will_auto_populate: "This will auto-populate the previous response and will override any “default” responses",
    threshold_settings: "Threshold Settings",
    thursday: "Thursday",
    ticket_id: "Ticket ID",
    time: "Time",
    time_elapsed: "Time Elapsed",
    time_management: "Time Management",
    time_manager: "Time Manager",
    time_submitted: "Time Submitted",
    timeframe: "Timeframe",
    timezone: "Timezone",
    timezones: "Timezones",
    title_is_required: "Title is required.",
    to: "to",
    to_be_scheduled: "to be scheduled",
    to_continue: "to continue",
    to_create_a_new_upload_set: "to create a new upload set",
    to_create_an_item_request: "to create an Item Request.",
    to_give_you_the_best_experience: "To give you the best experience",
    to_include_instructions: "to include Instructions.",
    to_include_media: "button to attach media to this project.",
    to_include_tools: "button to attach tools to this project.",
    to_populate_data: "to populate data.",
    to_select_any_item_requests: "to select any item requests.",
    today: "Today",
    tomorrow: "Tomorrow",
    too_many_reps_selected_500_max: "Too many reps selected. 500 max.",
    too_many_results: "Too Many Results",
    too_many_results_within: "Too many results within",
    too_many_staff_results_within_the_selected_filters: "Too many staff results within the selected filters",
    took_break: "Took Break",
    tool_assigned: "Tool assigned: Not permissioned to view",
    tool_items_added_to_project: "Tool Item(s) Added to Project",
    tool_name: "Tool Name",
    tools: "Tools",
    tools_title: "Tools",
    total_device_mileage: "Total Device Mileage",
    total_projects_completed: "Total Projects Completed",
    total_route_mileage: "Total Route Mileage",
    total_store_visits: "Total Store Visits",
    total_time_at_location: "Total Time at Location",
    total_time_at_locations_hours: "Total Time at Location (hours)",
    total_time_on_clock_by_day: "Total Time on Clock by Day",
    total_time_on_clock_hours: "Total Time on Clock (hours)",
    total_time_on_project: "Total Time on Project",
    total_time_on_project_hours: "Total Time on Project (hours)",
    total_visits_processed: "Total Visits Processed",
    tracking_numbers: "Tracking Number(s)",
    tuesday: "Tuesday",
    twelve_hours: "12 Hours",
    twenty_four_hours: "24 Hours",
    type: "Type",
    type_enter_search: "Type to search, Enter to select",
    type_message: "Type a Message",
    unable_complete_scheduling_error_message: "Unable to complete request. Please verify all scheduling parameters are valid.",
    unable_retrieve_tags_save_and_refresh: "Unable to retrieve tags. Please save your progress, then refresh the page to try again.",
    unable_to_create_gallery_required_fields: "We are unable to create your gallery because of the following required missing fields",
    unable_to_delete_section: "Unable to Delete Section",
    unable_to_schedule_visit_error_message_manage_permission: "Unable to Schedule this Visit because User does not have Scheduling/Manage Permission",
    unable_to_schedule_visit_to_unqualified_rep: "Unable to Schedule this Visit to an Unqualified Rep",
    unable_to_unassign_visit_error_message: "Unable to Unassign this Visit because MVID is null",
    unable_to_unassign_visit_error_message_manage_permission: "Unable to Unassign this Visit because User does not have Scheduling/Manage Permission",
    unassign: "Unassign",
    unassign_visit: "Unassign Visit",
    uncategorized: "Uncategorized",
    undefined: "Undefined",
    undo: "Undo",
    undo_changes: "Undo Changes",
    unit_of_measure: "miles",
    unit_of_measurement: "Unit of Measurement",
    united_states: "United States",
    unknown: "Unknown",
    unknown_contact: "Unknown Contact",
    unknown_mplan: "Unknown mPlan",
    unsaved_changes_warning: "You have unsaved changes. Are you sure you wish to continue?",
    unscheduled_visits: "Unscheduled Visits",
    unselect_all: "Unselect All",
    unstaffed_projects: "Unstaffed Projects",
    unstaffed_projects_tooltip: "Create visit escalation alerts to be sent to roles assigned to the project.",
    unsupported_file_type: "Unsupported File Type",
    upcoming: "Upcoming",
    update: "Update",
    update_attachment: "Update Attachment",
    update_custom_field: "Update Custom Field",
    update_global_attributes: "Update Global Attributes",
    update_list: "Update List",
    update_location_availability: "Update Location Availability",
    update_location_specific_attributes: "Update Location Specific Attributes",
    update_set: "Update Item Set",
    update_set_name: "Update Item Set Name",
    update_survey: "Update Survey",
    upload_a_file: "Upload a File",
    upload_csv: "Upload CSV",
    upload_files: "Upload Files",
    upload_new_image: " Upload New Image",
    upload_opt_in_contract: "Upload Opt In Contract",
    upload_or_drop_pdf: "Upload or drop your PDF below",
    upload_picture: "File to be uploaded",
    upload_values: "Upload Values",
    use_complete_confirmation: "Use Complete Confirmation",
    use_default_mvid: "Use Default MVID",
    use_for_assignments: "Use for Assignments",
    use_legacy_view: "Use Legacy View",
    use_sso: "Use SSO",
    use_work_approval: "Use Work Approval",
    use_work_escalation_alerts: "Use Work Escalation Alerts",
    user_action: "User Action",
    user_details: "User Details",
    user_facing: "User-facing",
    user_group_s: "User Group(s)",
    usergroups: "Usergroups",
    username: "Username",
    username_and_password_recovery: "Username and Password Recovery",
    username_or_password_is_incorrect: "Username or Password is Incorrect.",
    users: "Users",
    valid_phone_number: "Please enter a valid phone number.",
    validating_file_data: "Validating File Data...",
    value_can_not_have_more_decimals_than_selected: "Value cannot have more decimals than selected.",
    values: "Values",
    values_selected: "Value(s) Selected",
    vendor: "Vendor",
    vendor_dsd: "Vendor - DSD",
    vendor_non_dsd: "Vendor - Non DSD",
    vendors: "Vendors",
    verify_contract_continue: "Verify Contract to Continue",
    view: "View",
    view_assignment_summary: "View Assignment Summary",
    view_attachment: "View Attachment",
    view_details: "View Details",
    view_edit_visit_details: "View/Edit Visit Details",
    view_full_size: "View Full Size",
    view_images: "View Images",
    view_less: "View Less",
    view_locations: "View Locations",
    view_more: "View More",
    view_opportunities: "View Opportunities",
    view_rep_del: "View, replace or delete an attachment",
    view_responses: "View Responses",
    view_survey: "View Survey",
    view_tag_usage: "View Tag Usage",
    visit_activity: "Visit Activity",
    visit_details: "Visit Details",
    visit_details_deleted: "Visit Details Deleted",
    visit_id: "Visit ID",
    visit_reissued: "Visit Reissued",
    visit_selection: "Visit Selection",
    visit_status: "Visit Status",
    visit_successfully_scheduled: "Visit(s) Successfully Scheduled",
    visits_detailed: "Visits Detailed",
    visits_w_opportunities: "Visits with Opportunities",
    visits_w_opportunities_tooltip: "A visit that has Opportunities actively available for staff to accept or decline",
    visits_with_opportunity: "Visits with Opportunity",
    visualize_data: "Visualize Data",
    visualized_data: "Visualized Data",
    waiting_approval: "Waiting Approval",
    warnings: "Warnings",
    wednesday: "Wednesday",
    week: "week",
    week_capitalized: "Week",
    week_plural: "Week(s)",
    week_range_feedback: "Must be between 0-168",
    weekly: "Weekly",
    weekly_blank_error: "Number is required for every Week.",
    weekly_recurring_end_error: "week(s).",
    weekly_recurring_start_error: "This recurring cannot last longer than",
    weeks: "weeks",
    welcome: "Welcome",
    welcome_to_the_new_preference_management_tool: "Welcome to the new Preference Management Tool. Here you will be able to quickly and easily toggle on any Athena features. This is a work in progress and will become more and more robust over time.",
    what_is_the_latest_date: "What is the latest date that this project is available to start?",
    what_is_the_latest_date_time: "What is the latest date & time that this project is available to start?",
    when_should_this_project_become_available: "When should this project become available to start in the mobile app?",
    which_login_should_i_use: "Which Login Should I Use?",
    which_question: "Which Question(s)",
    who_share_report_with: "Who do you want to share this report with?",
    whole_number: "Whole Number",
    work: "Work",
    work_approval: "Work Approval",
    work_approval_help: "Manage whether any work submissions require admin approval in Work Hub Visit Details before the submission is finalized. By default, Use Work Approval is disabled.",
    work_escalation: "Work Escalation",
    work_escalation_alerts_help: "Create escalation alerts to notify location staff in the app when work is “late” or “at risk to be late”. This feature cannot be used with infinity Projects.",
    work_escalation_alerts_not_available_for_infinity_projects: "Work Escalation Alerts not available for Infinity Projects",
    work_escalation_configurations: "Work Escalation Configurations",
    work_hub: "Work Hub",
    work_log: "Work Log",
    work_log_date: "Work Log Date",
    work_type: "Project Type",
    work_type_help: "Select the type of project that best fits your need. Select \"Standard\" if you plan to define the number of times staff will complete work within this project. Select \"Infinity\" if you will need an indefinite number of work submissions for this project.",
    would_you_like_to_limit_to_most_recent_by_location: "Would you like to limit the results to the most recent submission by location?",
    would_you_like_to_save_these_selections_as_a_list: "Would you like to save these selections as a list?",
    year: "year",
    yearly: "Yearly",
    years: "years",
    yes: "Yes",
    yes_display_text: "Response Option Text - Planogram Completed",
    yes_no: "Yes / No",
    yes_score_value: "\"Yes\" Score Value",
    yesterday: "Yesterday",
    you_added_the_max_number_alerts_5: "Maximum number of alerts added.",
    you_are_about_to_cancel_a_reissued_visit: "You are about to cancel a reissued Visit",
    you_are_about_to_decline: "You are about to decline this opportunity for ",
    you_are_about_to_delete_master_questions_from_this_survey: "You are about to delete master question(s) from this survey",
    you_are_about_to_delete_this_parent_question: "You are about to delete this parent question",
    you_are_about_to_delete_this_question: "You are about to delete this question",
    you_are_scheduling_this_over_an_unavailability_window: "You are scheduling this over an unavailability window",
    you_have_edited_a_parent_question: "You have edited a parent question",
    you_have_selected: "You have selected",
    you_must_enter_value: "You must enter a value.",
    you_must_narrow_down_your_selected_locations_to_continue: "You must narrow down your selected locations to continue.",
    you_must_select_at_least_one_day: "You must select at least one day.",
    you_must_set_assignments_and_visits_to_create_opportunities: "You must set “Assignments & Visits” to create opportunities.",
    youll_need_to_add_filters_to_find_the_places_youre_looking_for: "you'll need to add filters to find the places you're looking for",
    youll_need_to_apply_filters_to_find_the_items_youre_looking_for: "you will need to apply filters to find the items you are looking for",
    your_ranges_are_overlapping: "Your ranges are overlapping",
    your_search_returned_too_many_records: "Your search returned too many records",
    zip: "Postal Code",
    zip_code: "Zip Code",
    zip_codes: "Zip Codes",
    upload_objects: "Upload List",
    added_objects: "Added Objects",
    object_lookup: "Lookup List",
    object_lookup_template: "Lookup List Template",
    this_question_requires_objects_lookup: "This question requires a Lookup List to be attached.",
    object_lookup_error: "Error in uploading Lookup List Template.",
    view_objects: "View List",
    file: "File",
};
